export default __webpack_public_path__ + "static/media/undraw_doctors_aids.0ce32a80.svg";